import {
  SET_COMPANIES_WITH_FEED_ACCESS,
  SET_SELECTED_COMPANY,
} from 'redux/constants/Company';

const initState = {
  companies: [],
  companiesWithFeedAccess: [],
  selectedCompany: '',
};

const company = (state = initState, action) => {
  switch (action.type) {
    case SET_COMPANIES_WITH_FEED_ACCESS:
      return {
        ...state,
        companies: action.payload,
        companiesWithFeedAccess: action.payload,
      };
    case SET_SELECTED_COMPANY:
      return {
        ...state,
        selectedCompany: action.payload,
      };
    default:
      return state;
  }
};

export default company;
